import { Document, Tags } from 'types';
import { downloadBlob } from 'utils/downloadBlob';
import { simplifyMentions } from '../../CKEditor/utils/simplifyMentions';
import tags from '../../EditorWYSIWYG/tags';
import { updateDocumentWithValues } from '../../EditorWYSIWYG/helpers';
import { getDocumentBlob } from '../../CKEditor/utils/getDocumentBlob';

type downloadTemplateDocumentProps = {
  document: Document;
  tagsObject?: Tags;
  isLandscape?: boolean;
};

export const downloadTemplateDocument = async ({
  document,
  tagsObject,
  isLandscape,
}: downloadTemplateDocumentProps) => {
  const tagsValues = tags(tagsObject);

  const noMentionsHtml = simplifyMentions(document?.editorModel || '');

  const documentWithValues = updateDocumentWithValues(
    noMentionsHtml,
    tagsValues
  );
  const blob = await getDocumentBlob({
    html: documentWithValues?.html || '',
    isLandscape,
  });

  return downloadBlob(blob, document?.name || '');
};
